import * as React from 'react';
import { SVGProps } from 'react';

const FileIconAviSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 34 40" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M32 0H2a2 2 0 0 0-2 2v36a2 2 0 0 0 2 2h30a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z" />
    <path
      opacity={0.6}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25 17v16H9V17h16Zm-2.823.889h1.882v.993h-1.883v-.993Zm0 14.222h1.882v-.993h-1.883v.993Zm0-1.934h1.882v-1.883h-1.883v1.883Zm0-2.824h1.882V25.47h-1.883v1.882Zm-.942-1.882v6.64h-8.47v-6.64h8.47Zm0-.942h-8.47v-6.64h8.47v6.64Zm.942 0h1.882v-1.882h-1.883v1.882Zm0-2.823h1.882v-1.883h-1.883v1.883Zm-10.354.941v1.882H9.941v-1.882h1.882Zm-1.882 4.706V25.47h1.882v1.882H9.941Zm0 .941v1.883h1.882v-1.883H9.941Zm0 3.817v-.993h1.882v.993H9.941Zm1.882-10.405v-1.883H9.941v1.883h1.882Zm-1.882-3.817v.993h1.882v-.993H9.941Z"
      fill="#fff"
    />
    <path d="M22 6V5h-1v1h1ZM20 7v1h1v3h-1v1h3v-1h-1V7h-2Z" fill="#fff" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.95 12a.66.66 0 0 1-.29-.08.818.818 0 0 1-.26-.22.73.73 0 0 1-.61.3h-1.34c-.507 0-.877-.1-1.11-.3-.227-.207-.34-.557-.34-1.05v-.1C11 9.517 11.487 9 12.46 9H14v-.35c0-.207-.063-.367-.19-.48-.127-.113-.313-.17-.56-.17H11.5V7h1.8c.58 0 1.007.127 1.28.38.28.253.42.66.42 1.22V11c0 .1.037.177.11.23.08.047.21.07.39.07v.7h-.55Zm-1.41-1c.2 0 .327-.047.38-.14a.72.72 0 0 0 .08-.36V10h-1.4a.583.583 0 0 0-.599.554c.008.146.048.255.119.326.08.08.207.12.38.12h1.04Z"
      fill="#fff"
    />
    <path d="M17 7h-1v3l1 2h1l1-2V7h-1v3h-1V7Z" fill="#fff" />
  </svg>
);
export default FileIconAviSizeM;
